<div class="main-farm">
    <form [formGroup]="parentForm" (ngSubmit)="submitForm()">
        <div class="main-farm-top">
            <div class="farm-header-with-back">
                <button
                    type="button"
                    class="btn-back"
                    (click)="goBack()"
                    title="Go back"
                >
                    <i class="fas fa-arrow-left"></i>
                </button>
                <div class="farm-title-description">
                    <h2>Farm Information</h2>
                    <p>Please add your farm information</p>
                </div>
            </div>
        </div>
        <div formArrayName="farms" class="main-farm-group">
            <div
                class="farm-add-group"
                *ngFor="let farmGroup of farms.controls; let i = index"
                [formGroupName]="i"
            >
                <div class="accordion">
                    <div class="accordion-header" (click)="setOpenFarm(i)">
                        <h3>{{ farmGroup.get('name').value }}</h3>
                    </div>
                    <div
                        class="accordion-body"
                        [ngClass]="{show: openFarmIndex === i}"
                    >
                        <app-add-farm
                            [farmFormGroup]="farmGroup"
                            [index]="i"
                            (removeFarmEvent)="removeFarm($event)"
                            (addFarmHouseEvent)="addFarmHouse($event)"
                        >
                        </app-add-farm>
                    </div>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-action-secondary"
                (click)="addFarm()"
                title="Add a new farm"
            >
                <i class="fas fa-plus"></i> Add Farm
            </button>
        </div>
        <div class="add-farm-submit">
            <!-- <button class="btn btn-primary btn-add-farm" type="submit">Submit</button> -->
            <button
                type="submit"
                class="btn btn-primary btn-add-farm"
                [disabled]="!isFormValid() || (isLoading$ | async)"
            >
                <span *ngIf="!isAuthLoading">Submit</span>
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
            <img
                *ngIf="isLoading$ | async"
                src="assets/img/loader.gif"
                alt="Loading..."
                class="loader-image mt-2"
            />
        </div>
    </form>
</div>
